import React from "react";

function AboutUs() {
    return (
        <>
            <div id="about-us-section" className="sales-landing-section">
                <div id="about" className="container-fluid about-us">
                    <div className="row">
                        <div className="col-12 col-lg-8 offset-lg-2">
                            <p>
                                For over 40 years, IdentityForce, a Sontiq brand, has provided best-in-class, highly scalable, award-winning identity theft, privacy
                                and credit protection solutions to consumers, businesses, and government agencies.
                            </p>
                            <p>
                                Our holistic approach to identity and credit protection incorporates robust technology, rigorous product testing and development,
                                best-in-class customer service, and open communication with our members and partners. So you, your family, or your business are
                                getting world-class identity theft protection. And that's a promise we continue to deliver on, every day.
                            </p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-5 offset-md-1">
                            <div className="video-wrapper">
                                <iframe
                                    src="//videos.sproutvideo.com/embed/7c9adbbe121ceaccf4/b6315762f07237ec"
                                    allowFullScreen={true}
                                    width="630"
                                    height="354"
                                    frameBorder="0"
                                ></iframe>
                            </div>
                        </div>
                        <div className="col-12 col-md-5">
                            <h3>We protect your identity like we protect our own.</h3>
                            <br />
                            <br />
                            <p>
                                Your identity is much more than just your personal information. It is everything you have worked for your entire life to create.
                                It's your home, your career, your family, your finances, your health, your business, your reputation, and everything that matters
                                most to you. It's your life story, and to us, it doesn't get any more personal than protecting it. Why? Because we're people with
                                identites, too. Which means what matters to you, matters to us.
                            </p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-4">
                            <img role="option" src={require("../../Assets/images/funnel/sales/owi_award_2019_web.png").default} alt="OWI Award 2019" />
                        </div>
                        <div className="col-4">
                            <img role="option" src={require("../../Assets/images/funnel/sales/ptpa_seal_of_approval_award.png").default} alt="PTPA Seal of Approval Award" />
                        </div>
                        <div className="col-4">
                            <img role="option" src={require("../../Assets/images/funnel/sales/globee_gold_2019.png").default} alt="Globee Gold 2019" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-4">
                            <img role="option"
                                src={require("../../Assets/images/funnel/sales/stevie_peoples_choice_award_logo_2019.png").default}
                                alt="Stevie Peoples choice Award 2019"
                            />
                        </div>
                        <div className="col-4">
                            <img role="option" src={require("../../Assets/images/funnel/sales/rcb_bbb.png").default} alt="RCB BBB" />
                        </div>
                        <div className="col-4">
                            <img role="option"
                                src={require("../../Assets/images/funnel/sales/a_secure_life_best_overall_coverage_and_value.png").default}
                                alt="Secure Life best overall coverage and value"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AboutUs;
